var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.703 4.622a3.427 3.427 0 0 0-3.413 0L6.866 8.337a3.412 3.412 0 0 0-1.7 2.958v7.41c0 1.213.65 2.34 1.7 2.957l6.435 3.716c1.051.607 2.351.607 3.413 0l6.435-3.716a3.412 3.412 0 0 0 1.7-2.957v-7.41a3.458 3.458 0 0 0-1.711-2.958l-6.435-3.715zm.823 7.854A2.52 2.52 0 0 1 15.002 15a2.52 2.52 0 0 1-2.524-2.524 2.527 2.527 0 0 1 2.524-2.524 2.52 2.52 0 0 1 2.524 2.524zM12.1 20.048c-.878 0-1.387-.975-.9-1.7.737-1.095 2.167-1.831 3.803-1.831 1.636 0 3.066.736 3.803 1.83.487.716-.033 1.701-.9 1.701H12.1z",
    fill: "#ED1C24",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16);
export default __webpack_public_path__ + "static/media/icon-16.707ecb6f77f65152b6eaee86d6c47a20.svg";
export { ForwardRef as ReactComponent };